const initialState = {
  appInitialized: false,
};

export default function configReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
